<template>
  <div class="EventsPage">
    <div v-show="isLoading">
      <PreLoad />
    </div>
    <div v-if="!isLoading" class="container">
      <StorySlider :stories="response.stories"/>
      <ImageSlider :images="response.sliders" v-if="755 < screen" />
      <ImageSliderMobile :images="response.sliders" v-if="755 >= screen" />
      <div v-for="(event, index) in events" :key="(event, index)" dir="rtl">
        <div class="d-flex justify-content-between wrap mt-4">
          <h2 class="text-end">{{event.name}}</h2>
          <div class="timer">
            <span class="mx-2" v-if="event.timer.days !== 0">{{event.timer.days}} روز</span> <span class="mx-2" v-if="event.timer.days !== 0 || event.timer.hours !==0">{{event.timer.hours}} ساعت</span> <span class="mx-2" v-if="event.timer.days !== 0 || event.timer.hours !==0 || event.timer.minutes !== 0">{{event.timer.minutes}} دقیقه</span> <span class="mx-2" v-if="event.timer.days !== 0 || event.timer.hours !==0 || event.timer.minutes !== 0 || event.timer.seconds !== 0">{{event.timer.seconds}} ثانیه</span>
          </div>
        </div>
        <BrandCarousel :objects="event.brands"/>
        <ProductCarousel v-if="event.products" :objects="event.products"/>
        <ProductCarousel v-if="!event.products"/>
        <div class="load-more">
          <router-link :to="'/gift/' + event.slug" class="btn btn-secondary mt-4 mb-3" >مشاهده بیشتر</router-link>
        </div>
        <hr v-if="index !== events.length - 1" />
      </div>
      <div class="mt-3 mb-5">
        <div class="bg-club">
          <div class="form-group p-5" dir="rtl">
            <p for="formGroupExampleInput" class="text-center club-label">برای دریافت خبرها و تخفیف‌ها شماره همراه خود را وارد کنید.</p>
            <div class="club-input my-4">
              <input type="text" class="form-control without-border-radius" v-model="clubNumber" id="formGroupExampleInput" placeholder="شماره موبایل ...">
              <button aria-label="ثبت" @click="sendToClub(clubNumber)" type="button" class="btn btn-secondary club-btn right-input-btn">ثبت</button>
            </div>
          </div>
        </div>
      </div>
      <PageContent mode="EventsPage" />
    </div>
  </div>
</template>
<script>
import ImageSlider from '@/components/ImageSlider.vue'
import ImageSliderMobile from '@/components/ImageSliderMobile.vue'
import PageContent from '@/components/PageContent.vue'
import { useTimer } from 'vue-timer-hook'
import BrandCarousel from '@/components/BrandCarousel.vue'
import ProductCarousel from '@/components/ProductCarousel.vue'
import StorySlider from '@/components/StorySlider.vue'
import PreLoad from '@/components/PreLoad.vue'

export default {
  name: 'EventsPage',
  components: {
    ImageSlider,
    ImageSliderMobile,
    PageContent,
    BrandCarousel,
    ProductCarousel,
    StorySlider,
    PreLoad
  },
  data () {
    return {
      response: {},
      events: [],
      screen: screen.width,
      clubNumber: '',
      isLoading: true
    }
  },
  mounted () {
    const query = `
{
  events {
    secondsTo
    name
    slug
    brands {
      name
      slug
    }
    products {
      id
      available
      slug
      name
      image: PNG
      mlActivation
      specialTag
      concepts: concepts {
        id
        price
        name
        video
        videoCover
        image
        description
      }
      isOffInt
      priceAfterOff
      priceBeforeOff: priceBeforeOff
      categorySlug
      subCategorySlug
      categoryId
    }
  }
  meta(key:"${this.$options.name}") {
    seoTitle
    seoKeyword
    seoDescription
  }
  sliders (key: "EventsPage") {
    imageMobile
    image
    alt
    link
  }
  stories (key: "EventsPage") {
    id
    videoCover
    link
    video
    prev
    next
  }
}
    `
    this.$fetchGraphQL(query).then(response => {
      this.response = response.data
      this.setMetaByObj(response.data.meta)
      this.events = response.data.events
      for (const x in this.events) {
        const time = new Date()
        time.setSeconds(time.getSeconds() + this.events[x].secondsTo) // 10 minutes timer
        this.events[x].timer = useTimer(time)
      }
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
hr{
  height:3px;
  color:gray;
}
.load-more{
  display: flex;
  justify-content: center;
}
.wrap{
  flex-wrap: wrap;
}
.timer{
  font-size: 14pt;
  color: #ff5f5f;
  letter-spacing: -1px;
  margin: 10px;
}
.drop-shadow{
  filter: drop-shadow(0px 2px 5px rgba(50, 50, 0, 0.2));
}
img{
  width: -webkit-fill-available;
  border-radius: 24px;
}
.title-c{
  color: white;
  background: #808080b3;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 12px;
}
</style>
